export { getUserInfoServerAction } from 'next-flight-server-reference-proxy-loader?id=7f9e2d76e849775ac628cd505158df4d80d1f73fe7&name=getUserInfoServerAction!'